The response from the `deleteWebhookSubscription` mutation.
